export default "__VITE_ASSET__C_3GXXsa__"